import { render, staticRenderFns } from "./Restaurar.vue?vue&type=template&id=5b0d0e9c&"
import script from "./Restaurar.vue?vue&type=script&lang=js&"
export * from "./Restaurar.vue?vue&type=script&lang=js&"
import style0 from "./Restaurar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports